"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types")); // Used in PixelDebugRow, defined in Pixelmon - all we care about for now is name and event


var pixelConfig = _propTypes["default"].shape({
  name: _propTypes["default"].string,
  event: _propTypes["default"].string
}); // Used in PixelRecordView, defined in Pixelmon - it's the object provided when Pixelmon fires a 'pixel' event


var pixelRecord = _propTypes["default"].shape({
  pixelConfig: pixelConfig,
  renderedHtmlTemplate: _propTypes["default"].string,
  context: _propTypes["default"].object
});

var _default = {
  pixelConfig: pixelConfig,
  pixelRecord: pixelRecord
};
exports["default"] = _default;